import { useContext, useEffect, useState } from 'react';
import './AddProductPopup.css';
import AdaptivePopup from '../../../../AdaptivePopup/AdaptivePopup';
import Button from '../../../../Button/Button';
import { StringOrNothingFormater, getMinPrice, parsePrice } from '../../../../../assets/utils/utils';
import SearchProductPopup from '../SearchProductPopup/SearchProductPopup';
import { CrossIcon } from '../../../../../assets/icons/controls/controls';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import CreateProductPopup from '../CreateProductPopup/CreateProductPopup';

function AddProductPopup({ isOpen, handleClose, items, handleAddItem }) {
    const [popups, setPopups] = useState({
        searchAddProduct: false,
        createProduct: false,
    });



    function onClosePopup() {
        handleClose();
        setTimeout(() => {
            // Do any cleanup if needed
        }, 300);
    }

    function handleCloseSearchAddProductPopup() {
        setPopups(prevValue => ({
            ...prevValue,
            searchAddProduct: false,
        }))
    }

    function handleCloseCreateProductPopup() {
        setPopups(prevValue => ({
            ...prevValue,
            createProduct: false,
        }))
    }

    return (
        <>
            <AdaptivePopup
                isOpen={isOpen}
                handleClose={onClosePopup}
                popupName={'editProducts'}
            >

                <div className='add-products-popup'>
                    <div className='add-products-popup__heading'>
                        <p className='add-products-popup__title'>Добавить товар в заказ</p>
                        <button className='add-products-popup__close' type='button' >
                            <CrossIcon mainClassName={'add-products-popup__close-icon'} strokeClassName={'add-products-popup__close-icon-stroke'} />
                        </button>
                    </div>


                    <Button
                        text={'Найти товар на сайте'}
                        className={'add-products-popup__btn add-products-popup__btn_secondary'}
                        onClick={() => {
                            setPopups(prevValue => ({
                                ...prevValue,
                                searchAddProduct: true,
                            }))
                        }}
                    />
                    <Button
                        text={'Создать свободный товар'}
                        isContrastColor
                        className={'add-products-popup__btn '}
                        onClick={() => {
                            setPopups(prevValue => ({
                                ...prevValue,
                                createProduct: true,
                            }))
                        }}
                    />
                </div>
            </AdaptivePopup>
            <SearchProductPopup
                isOpen={popups.searchAddProduct}
                handleClose={handleCloseSearchAddProductPopup}
                block={items}
                handleSelect={handleAddItem}
            />
            <CreateProductPopup
                isOpen={popups.createProduct}
                handleClose={handleCloseCreateProductPopup}
                block={items}
                handleSelect={handleAddItem}
            />
        </>

    );
}

export default AddProductPopup;
